export const keys = {
    arrowDown: 'ArrowDown',
    arrowUp: 'ArrowUp',
    enter: 'Enter',
    escape: 'Escape',
    space: ' ',
    tab: 'Tab'
};
